import { Component } from '@angular/core';

@Component({
  templateUrl: './model-portfolios.component.html',
  styleUrls: ['../../shared/static-pages.scss'],
  standalone: false
})
export class ModelPortfoliosComponent { }
